import { createAction, props } from '@ngrx/store';
import { MediaType } from '../../gallery/media-type.enum';
import { HubMediaState } from './media.reducer';
import { MediaFile } from '../../gallery/media-file.model';

export const setMediaData = createAction(
  '[Media] Set media data',
  props<{ data: HubMediaState }>()
);

export const resetMediaData = createAction(
  '[Media] Reset media data',
);

export const addNewMediaFileInStore = createAction(
  '[Media] Add new media file in store',
  props<{ item: MediaFile }>()
);
